import { cj } from 'src/utils/classNames';

interface Props {
	progressBarPercentage: number;
}

export default function FeeTierModalProgressBar({
	progressBarPercentage,
}: Props) {
	return (
		<div className="relative">
			{/* Background track */}
			<div className="h-2 w-full overflow-hidden rounded-full bg-button-secondary-bg">
				{/* Progress fill */}
				<div
					className="h-full rounded-full bg-positive-green transition-all duration-300 ease-out-smooth"
					style={{ width: `${progressBarPercentage}%` }}
				/>
			</div>
			{/* Circular handle */}
			<div
				className={cj(
					'absolute top-1/2 size-3 -translate-y-1/2 border-2 border-container-bg',
					'transform rounded-full bg-positive-green transition-all duration-300 ease-out'
				)}
				style={{ left: `calc(${progressBarPercentage}% - 4px)` }}
			/>
		</div>
	);
}
